export default "__VITE_ASSET__QF4fGtKk__"